import { render, staticRenderFns } from "./new-landing.vue?vue&type=template&id=706464b7&"
import script from "./new-landing.vue?vue&type=script&lang=ts&"
export * from "./new-landing.vue?vue&type=script&lang=ts&"
import style0 from "./new-landing.vue?vue&type=style&index=0&id=706464b7&prod&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports